import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvestorInvitationController::store
* @see app/Http/Controllers/InvestorInvitationController.php:31
* @route '//app.finesthub.de/invitations'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/invitations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\InvestorInvitationController::store
* @see app/Http/Controllers/InvestorInvitationController.php:31
* @route '//app.finesthub.de/invitations'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvestorInvitationController::store
* @see app/Http/Controllers/InvestorInvitationController.php:31
* @route '//app.finesthub.de/invitations'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\InvestorInvitationController::destroy
* @see app/Http/Controllers/InvestorInvitationController.php:75
* @route '//app.finesthub.de/invitations/{naturalPerson}'
*/
export const destroy = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/invitations/{naturalPerson}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\InvestorInvitationController::destroy
* @see app/Http/Controllers/InvestorInvitationController.php:75
* @route '//app.finesthub.de/invitations/{naturalPerson}'
*/
destroy.url = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { naturalPerson: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { naturalPerson: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
    }

    return destroy.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvestorInvitationController::destroy
* @see app/Http/Controllers/InvestorInvitationController.php:75
* @route '//app.finesthub.de/invitations/{naturalPerson}'
*/
destroy.delete = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\InvestorInvitationController::accept
* @see app/Http/Controllers/InvestorInvitationController.php:16
* @route '//app.finesthub.de/invitations/{token}'
*/
export const accept = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: accept.url(args, options),
    method: 'get',
})

accept.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/invitations/{token}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvestorInvitationController::accept
* @see app/Http/Controllers/InvestorInvitationController.php:16
* @route '//app.finesthub.de/invitations/{token}'
*/
accept.url = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { token: args }
    }

    if (Array.isArray(args)) {
        args = {
            token: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        token: args.token,
    }

    return accept.definition.url
            .replace('{token}', parsedArgs.token.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvestorInvitationController::accept
* @see app/Http/Controllers/InvestorInvitationController.php:16
* @route '//app.finesthub.de/invitations/{token}'
*/
accept.get = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: accept.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvestorInvitationController::accept
* @see app/Http/Controllers/InvestorInvitationController.php:16
* @route '//app.finesthub.de/invitations/{token}'
*/
accept.head = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: accept.url(args, options),
    method: 'head',
})

const InvestorInvitationController = { store, destroy, accept }

export default InvestorInvitationController